import React from "react";
import { PoliticaDeCookiesBody, PrivacySection, PrivacySectionContent, Title, TocLink, TocSticky } from "./styles";
import { Hr } from "../LgpdAvisoPrivacidadeHome/styles";

export default function LgpdPoliticaDeCookiesHome(...props) {
    return (
        <PoliticaDeCookiesBody>
            <Title>
                <h1>POLÍTICA DE COOKIES GRUPO CEREAL</h1>
                <Hr />
            </Title>
            <div className="container mb-5" data-bs-spy="scroll" data-bs-target=".toc-sticky" data-bs-offset="110" tabIndex="0">
                <div className="row">
                    <div className="col-lg-3 mb-4">
                        <PrivacySection>
                            <TocSticky>
                                <h4 className="mb-4">Sumário</h4>
                                <nav>
                                    <ul className="list-unstyled">
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#objetivo">1. Objetivo da Política de cookies</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink>
                                                <a href="#o-que-sao">2. O que são cookies?</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink href="">
                                                <a href="#finalidades">3. Para quais finalidades os cookies são utilizados?</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink href="#dados-coletados">
                                                <a href="#dados-coletados">4. Quais dados podem ser coletados pelo uso dos cookies?</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink href="#tipos-cookies">
                                                <a href="#tipos-cookies">5. Quais são os tipos de cookies?</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink href="#como-gerenciar">
                                                <a href="#como-gerenciar">6. Como gerenciar o uso de cookies no site do Grupo Cereal?</a>
                                            </TocLink>
                                        </li>
                                        <li className="mb-2">
                                            <TocLink href="#informacoes-adicionais">
                                                <a href="#informacoes-adicionais">7. Informações adicionais sobre a segurança dos seus dados.</a>
                                            </TocLink>
                                        </li>
                                    </ul>
                                </nav>
                            </TocSticky>
                        </PrivacySection>
                    </div>
                    <div className="col-lg-9">
                   <PrivacySectionContent id="objetivo">
                            
                            <div>
                                <h2>1. Objetivo da Política de Cookies</h2>
                            </div>
                            <p>
                                Diante do compromisso do <strong>Grupo Cereal</strong> com a privacidade do Usuário, foi elaborada esta Política de
                                Cookies com o objetivo de informar o que são cookies, para quais finalidades o <strong>Grupo Cereal </strong>
                                os utiliza, quais dados são coletados e como você pode controlar a sua coleta.
                            </p>
                            </PrivacySectionContent>
                            <PrivacySectionContent id="o-que-sao">
                            <div>
                                <h2>2. O que são cookies?</h2>
                            </div>
                            <p>
                                Cookies são arquivos ou informações que podem ser armazenadas em seus dispositivos quando você visita websites ou
                                utiliza os serviços online do <strong>Grupo Cereal</strong>. Geralmente, um cookie contém o nome do site que o
                                originou, seu tempo de vida e um valor, que é gerado aleatoriamente.
                            </p>
                            <p>
                                Quando o Usuário acessa os serviços online do <strong>Grupo Cereal</strong>, informações pessoais são armazenadas em
                                um cookie e enviadas ao seu navegador da internet ou dispositivo móvel pelo servidor do <strong>Grupo Cereal</strong>,
                                que então as guarda para uso posterior.
                            </p>
                            <p>
                                O cookie é atribuído individualmente a cada computador/dispositivo móvel e pode ser lido apenas pelo servidor que o
                                enviou. Assim, é incapaz de ser utilizado para infectar computadores/dispositivos móveis com códigos maliciosos de
                                qualquer espécie, tais como vírus, trojans e outros.
                            </p>
                        </PrivacySectionContent>
                        <PrivacySectionContent id="finalidades" >
                            <div>
                                <h2>3. Para quais finalidades os cookies são utilizados?</h2>
                            </div>
                            <p>Este site utiliza cookies para alcançar as seguintes finalidades:</p>
                            <p>a) Permitir a identificação e autenticação seguras dos usuários que o acessam;</p>
                            <p>
                                b) Tornar mais ágeis as solicitações, o fornecimento e o monitoramento de serviços prestados pelo{" "}
                                <strong>Grupo Cereal</strong>, priorizando a experiência do Usuário;
                            </p>
                            <p>
                                c) Permitir a personalização, a análise de tráfego e a coleta de dados analíticos e de desempenho, para otimizar o
                                funcionamento das páginas e aprimorar a experiência de navegação;
                            </p>
                            <p>d) Minimizar riscos relacionados a fraudes;</p>
                            <p>
                                e) Simplificar o acesso às redes sociais vinculadas ao <strong>Grupo Cereal</strong>.
                            </p>
                        
                        </PrivacySectionContent>
                        <PrivacySectionContent id="dados-coletados" >
                            <div>
                                <h2>4. Quais dados podem ser coletados pelo uso dos cookies?</h2>
                            </div>
                            <p>
                                Por meio de cookies, o site armazena informações sobre a atividade do navegador, incluindo endereço IP e a página
                                acessada. Esses registros de atividades (<em>logs</em>) serão utilizados apenas para as finalidades acima bem como
                                para fins estatísticos e de métricas dos serviços disponibilizados ou para a investigação de fraudes ou de alterações
                                indevidas em seus sistemas e cadastros, não tendo como finalidade o fornecimento dos dados a terceiros sem autorização
                                expressa do Usuário.
                            </p>
                            <p>Esses registros poderão compreender dados como:</p>
                            <p>a) Nome;</p>
                            <p>b) E-mail;</p>
                            <p>c) O endereço IP do Usuário;</p>
                            <p>d) Ações efetuadas no site;</p>
                            <p>e) Páginas acessadas;</p>
                            <p>f) Datas e horários de cada ação;</p>
                            <p>g) Datas e horários de cada acesso a cada página do site;</p>
                            <p>h) Informações sobre o dispositivo utilizado;</p>
                            <p>i) Versão de sistema operacional;</p>
                            <p>j) Navegador e outros aplicativos instalados.</p>
                        
                        </PrivacySectionContent>
                        <PrivacySectionContent id="tipos-cookies">
                            <div>
                                <h2>5. Quais são os tipos de cookies existentes?</h2>
                            </div>
                            <p>Os cookies podem ser divididos de acordo com a informação que armazenam e sua finalidade, a saber:</p>
                            <p>
                                a) <strong>Cookies necessários:</strong> São essenciais para que o website do
                                <strong>Grupo Cereal</strong> carregue corretamente e permita que o Usuário navegue corretamente, bem como utilize
                                todas as funcionalidades disponíveis.
                            </p>
                            <p>
                                b) <strong>Cookies de Desempenho:</strong> Ajudam a entender como os visitantes interagem com a página do{" "}
                                <strong>Grupo Cereal</strong>, fornecendo informações sobre as áreas visitadas, o tempo de visita ao site e quaisquer
                                problemas encontrados, como mensagens de erro.
                            </p>
                            <p>
                                c) <strong>Cookies Funcionais:</strong> Permitem que a página se lembre de suas escolhas, para proporcionar uma
                                experiência personalizada. Possibilitam que os Usuários assistam a vídeos, utilizem ferramentas sociais, campos para
                                comentários, fóruns e dentre outros.
                            </p>
                            <p>
                                d) <strong>Cookies de Marketing:</strong> São utilizados para fornecer mais conteúdo relevante e do interesse dos
                                Usuários. Podem ser utilizados para apresentar publicidade com um maior direcionamento ou limitar o número que esta é
                                veiculada. Também permitem a medição da eficácia de uma campanha publicitária lançada. Não são utilizados pelo
                                <strong> Grupo Cereal</strong>.
                            </p>
                        </PrivacySectionContent>
                        <PrivacySectionContent  id="como-gerenciar" >
                       
                            <div>
                                <h2>6. Como gerenciar o uso de cookies no site do Grupo Cereal?</h2>
                            </div>
                            <p>
                                A maioria dos navegadores da Internet e dispositivos móveis aceitam cookies. Entretanto, os usuários podem configurar
                                seus navegadores e dispositivos para recusar certos tipos de cookies ou cookies específicos. Além disso, os usuários
                                podem apagar os cookies a qualquer momento.
                            </p>
                            <p>
                                A qualquer momento você poderá revogar a sua autorização quanto à utilização dos cookies, utilizando as configurações
                                dos cookies disponíveis no nosso site e utilizando as configurações de seu navegador de preferência.
                            </p>
                            <p>
                                Contudo, alertamos que de acordo com a escolha realizada, certas funcionalidades poderão não operar da maneira
                                idealmente esperada. Para mais informações sobre como gerir os cookies diretamente em seu navegador, o{" "}
                                <strong>Grupo Cereal</strong> orienta a consulta aos links abaixo:
                            </p>
                            <p>Internet Explorer:</p>
                            <p>
                                <a href="https://support.microsoft.com/pt-br/help/17442/windows-internetexplorer-delete-manage-cookies">
                                    https://support.microsoft.com/pt-br/help/17442/windows-internetexplorer-delete-manage-cookies
                                </a>
                            </p>
                            <p>Mozilla Firefox:</p>
                            <p>
                                <a href="https://support.mozilla.org/pt-BR/kb/cookies-informacoes-sites-armazenam-no-computador">
                                    https://support.mozilla.org/pt-BR/kb/cookies-informacoes-sites-armazenam-no-computador
                                </a>
                            </p>
                            <p>Google Chrome:</p>
                            <p>
                                <a href="https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=pt-BR">
                                    https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=pt-BR
                                </a>
                            </p>
                            <p>Safari:</p>
                            <p>
                                <a href="https://support.apple.com/pt-br/guide/safari/sfri11471/mac">
                                    https://support.apple.com/pt-br/guide/safari/sfri11471/mac
                                </a>
                            </p>
                            </PrivacySectionContent>
                            <PrivacySectionContent id="informacoes-adicionais">
                       
                            <div>
                                <h2>7. Informações adicionais sobre a segurança dos seus dados.</h2>
                            </div>
                            <p>
                                Estamos comprometidos em manter os seus dados pessoais seguros. Para mais informações sobre como se dá o tratamento
                                dos seus dados pessoais pelo <strong>Grupo Cereal</strong>, por favor, leia o nosso Aviso de Privacidade ou entre em
                                contato conosco, por meio do e-mail <a href="mailto:dpo@grupocereal.com.br">dpo@grupocereal.com.br</a> ou por meio do
                                link <a href="https://lgpdgrupocereal.nuvemx.com.br">https://lgpdgrupocereal.nuvemx.com.br</a>.
                            </p>
                            </PrivacySectionContent>
                    </div>
                </div>
            </div>
        </PoliticaDeCookiesBody>
    );
}
